var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "wpdonation-box" },
    [
      _vm.strings
        ? _c("h2", { staticClass: "wpdonation-title" }, [
            _vm._v(_vm._s(_vm.strings.title))
          ])
        : _vm._e(),
      _vm._v(" "),
      _c("div", { staticClass: "easy-donation-box" }, [
        _c("div", { staticClass: "single-credit-cardd" }, [
          _c("div", { staticClass: "wpcm-row wpmc-justify-content-center" }, [
            _c("div", { staticClass: "wpcm-col-md-6" }, [
              _c("div", { staticClass: "textfield" }, [
                _c("input", {
                  attrs: {
                    type: "text",
                    placeholder: _vm.trans("first_name"),
                    disabled: _vm.loading,
                    required: ""
                  },
                  domProps: { value: _vm.billing_fields.first_name },
                  on: {
                    input: function($event) {
                      return _vm.setBillingValue(
                        "first_name",
                        $event.target.value
                      )
                    }
                  }
                })
              ])
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "wpcm-col-md-6" }, [
              _c("div", { staticClass: "textfield" }, [
                _c("input", {
                  attrs: {
                    type: "text",
                    placeholder: _vm.trans("last_name"),
                    disabled: _vm.loading,
                    required: ""
                  },
                  domProps: { value: _vm.billing_fields.last_name },
                  on: {
                    input: function($event) {
                      return _vm.setBillingValue(
                        "last_name",
                        $event.target.value
                      )
                    }
                  }
                })
              ])
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "wpcm-col-md-12" }, [
              _c("div", { staticClass: "textfield" }, [
                _c("input", {
                  attrs: {
                    type: "email",
                    placeholder: _vm.trans("email"),
                    readonly: _vm.is_logged_in && _vm.email,
                    disabled: _vm.loading,
                    required: ""
                  },
                  domProps: { value: _vm.billing_fields.email },
                  on: {
                    input: function($event) {
                      return _vm.setBillingValue("email", $event.target.value)
                    }
                  }
                })
              ])
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "wpcm-col-md-12" }, [
              _c("div", { staticClass: "textfield" }, [
                _c("input", {
                  attrs: {
                    type: "text",
                    placeholder: _vm.trans("address"),
                    disabled: _vm.loading
                  },
                  domProps: { value: _vm.billing_fields.address },
                  on: {
                    input: function($event) {
                      return _vm.setBillingValue("address", $event.target.value)
                    }
                  }
                })
              ])
            ])
          ])
        ])
      ]),
      _vm._v(" "),
      _vm._t("default")
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }